import { jsx as _jsx } from "react/jsx-runtime";
import { SymbolSearchModal } from "./SymbolSearchModal";
import { VNSymbolSearch } from "./VNSymbolSearch";
export function SymbolCompareModal(p) {
    return (_jsx(SymbolSearchModal, { open: true, onClose: p.onClose, children: _jsx(VNSymbolSearch, { mode: "unified", flat: true, defaultAction: "compare", allowSwitch: false, mainSymbol: p.mainSymbol, adapter: p.adapter, client: p.client, onChange: p.onSwitch, onTimeframeChange: p.onTimeframeChange, compare: { existing: p.existing, entries: p.entries, onAdd: p.onAdd, onRemove: p.onRemove, onUpdate: p.onUpdate } }) }));
}
